var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"Dynamic Numbering System","breadcrumb":"Dashboard > Settings > Dynamic Numbering System"}}),_c('dns-data-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }